import { Typography, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { Integration } from '@/types/integrations'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'
import { useDeleteIntegration } from '@/service-library/hooks/integrations'
import { showErrorSnackbar, showSuccessSnackbar } from '@/utils/snackbars'
import queryKeys from '@/service-library/query-keys'

type DeleteIntegrationDialogProps = {
  integration: Integration
  overlay: OverlayState
  onSuccess?: () => void
}

export default function DeleteIntegrationDialog({
  integration,
  overlay,
  onSuccess,
}: DeleteIntegrationDialogProps) {
  const { deleteIntegration, isPending } = useDeleteIntegration({
    listQueryKey: queryKeys.integrations.all,
    onSuccess: () => {
      showSuccessSnackbar('Integration Deleted')
      overlay.close()
      onSuccess?.()
    },
    onError: () => {
      showErrorSnackbar('Failed to delete integration. Please try again later.')
    },
  })

  return (
    <Dialog {...overlay} title="Delete Integration" maxWidth="xs">
      <DialogContent>
        <Typography>
          You are about to delete this integration. Are you sure?
        </Typography>
      </DialogContent>

      <DialogFooter>
        <Button variant="text" onClick={overlay.close} disabled={isPending}>
          Cancel
        </Button>
        <LoadingButton
          loading={isPending}
          onClick={() => {
            deleteIntegration(integration.id)
          }}
          variant="contained"
          color="error"
        >
          Delete
        </LoadingButton>
      </DialogFooter>
    </Dialog>
  )
}
